import { useModal } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import { AddStopChoiceContent } from "../ui/components/add-stop-choice.content";

export interface OpenAddStopChoiceOptions {
  onCreate: () => void;
  onPickExisting: () => void;
}

/**
 * Asks where the next stop comes from — new work or a job the system already
 * has. Either answer closes this modal and opens the matching picker.
 */
export function useAddStopChoiceModal() {
  const { openModal, closeModal } = useModal();
  const t = useT();

  const openAddStopChoice = ({ onCreate, onPickExisting }: OpenAddStopChoiceOptions) => {
    const id = openModal({
      size: "custom",
      width: { md: 520 },
      title: (
        <span className="text-[22px] font-bold leading-7 tracking-[-0.11px] text-text-primary">
          {t(Namespace.Routes, "addStopChoiceTitle")}
        </span>
      ),
      closeButtonTop: "top-5",
      headerClassName: "min-h-16 !p-4",
      bodyClassName: "!p-0 border-t border-border-primary",
      body: (
        <AddStopChoiceContent
          onCreate={() => {
            closeModal(id);
            onCreate();
          }}
          onPickExisting={() => {
            closeModal(id);
            onPickExisting();
          }}
        />
      ),
    });
    return id;
  };

  return { openAddStopChoice };
}
